// extracted by mini-css-extract-plugin
export default {"iconCounter":"InputCounter_iconCounter__8fBxY","inputContainer":"InputCounter_inputContainer__GODwZ"};